import React from 'react';
import '../styles/Footer.css';
import FooterLogo from '../assets/white-logo.png'
import MessageSVG from '../assets/mail.svg'
import PhoneSVG from '../assets/phone-call.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faLinkedinIn, faYoutube } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
    const footerSocialMedia = [
        { link: '/#', logo: faFacebookF },
        { link: '/#', logo: faInstagram },
        { link: '/#', logo: faLinkedinIn },
        { link: '/#', logo: faYoutube }];
    const addressData = [
        { country: 'United States', location: '4034 W Lawrence Ave, STE 3, Chicago, IL 60630, USA' },
        { country: 'India', location: 'A 204, Nirman Complex, Opp Hocco Restaurant, Navrangpura, Ahmedabad-380009   ' }];
    const quickLinks = [
        { url: '/register', title: 'Register with Amderon' },
        { url: '/star-lawyers', title: 'Our Star Lawyers' },
        { url: '/services', title: 'Our Services' },
        { url: '/about', title: 'About Us' },
        { url: '/contact', title: 'Contact Us' }]
    const contactInfo = [
        { country: 'United States', email: 'amderoninc@gmail.com', phone: '+1 909 490 9086' },
        { country: 'India', email: 'amderonamd@gmail.com', phone: '+91 999 801 0077' }]
    return (
        <footer>
            <div className="row">
                <div className="footer_wrapper">
                    <div className="footer_logo-social-media">
                        <a href="/#" className="footer_top-link">
                            <img src={FooterLogo} alt="" className="footer_logo" />
                        </a>
                        <ul className="footer_social-media-links">
                            {footerSocialMedia.map((socialMedia, index) => {
                                return (
                                    <li key={index} className='footer_sm-link-item'>
                                        <a href={socialMedia.link} className="footer_social-media-link">
                                            <FontAwesomeIcon icon={socialMedia.logo} />
                                        </a>
                                    </li>)
                            })}
                        </ul>
                    </div>
                    <ul className="footer_addresses">
                        {
                            addressData.map((address, index) => {
                                return (
                                    <li className="footer_address" key={index}>
                                        <h3 className="footer_address-country footer_country">{address.country}</h3>
                                        <p className="footer_address-location">{address.location}</p>
                                    </li>
                                )
                            })
                        }
                    </ul>
                    <ul className="footer_quick-links">
                        <h2 className="footer_quick-links-title footer_title">Quick Links</h2>
                        {
                            quickLinks.map((quickLink, index) => {
                                return (
                                    <li key={index} className='footer_quick-link-item'>
                                        <a href={quickLink.url} className="footer_quick-link">{quickLink.title}</a>
                                    </li>
                                )
                            })
                        }
                    </ul>
                    <ul className="footer_contact-info">
                        <h2 className="footer_contact-info-title footer_title">Contact Info</h2>
                        {
                            contactInfo.map((info, index) => {
                                return (
                                    <div className="footer_contact" key={index}>
                                        <h3 className="footer_contact-country-title footer_country">{info.country}</h3>
                                        <div className="footer_contact-mail-wrapper">
                                            <img src={MessageSVG} alt="" className="footer_contact-mail-svg" />
                                            <p className="footer_contact-email">{info.email}</p>
                                        </div>
                                        <div className="footer_contact-phone-wrapper">
                                            <img src={PhoneSVG} alt="" className="footer_contact-phone-svg" />
                                            <p className="footer_contact-phone">{info.phone}</p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </ul>
                    <p className="footer_copyrights">Copyrights © Amderon Enterprise. All rights reserved</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;